import BaseResource from './index'
import BoardResource from './board'

export default class RankedRaceResource extends BaseResource {
    static endpoint = '/races/rounds'

    static related() {
        return {
            board: BoardResource
        }
    }

    get dateTime() {
        return this.attributes.date_time ? new Date(this.attributes.date_time) : null
    }

    toString() {
        return this.attributes.name
    }
}
